var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export function fetchPagedData(fn, params) {
    return __awaiter(this, void 0, void 0, function* () {
        let page = 1;
        let totalRecords = 0;
        let results = [];
        do {
            const currentParams = Object.assign(Object.assign({}, (params || {})), { page });
            try {
                const response = yield fn(currentParams);
                if (!response || !response.data || !response.data.length)
                    break;
                results = results.concat(response.data);
                totalRecords = response.total;
                page++;
            }
            catch (error) {
                throw new Error(`Error fetching page ${page}: ${error}`);
            }
        } while (results.length <= totalRecords);
        return results;
    });
}
//# sourceMappingURL=fetchPagedData.js.map